export default "__VITE_ASSET__ObGnqpZX__"